import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { InterviewTemplatesEffects } from './store/interview-templates/interview-templates.effects';
import {
  InterviewTemplateNamespace,
  InterviewTemplateReducer,
} from './store/interview-templates/interview-templates.store';
import { InterviewTemplatesCategoriesEffects } from './store/interview-templates-categories/interview-templates-categories.effects';
import {
  InterviewTemplateCategoriesNamespace,
  InterviewTemplateCategoriesReducer,
} from './store/interview-templates-categories/interview-templates-categories.store';
import { InterviewTemplateDetailsEffects } from './store/interview-templates-details/interview-template-details.effects';
import {
  InterviewTemplateDetailsNamespace,
  InterviewTemplateDetailsReducer,
} from './store/interview-templates-details/interview-template-details.store';

@NgModule({
  imports: [
    StoreModule.forFeature(InterviewTemplateNamespace, InterviewTemplateReducer),
    StoreModule.forFeature(
      InterviewTemplateCategoriesNamespace,
      InterviewTemplateCategoriesReducer,
    ),
    StoreModule.forFeature(InterviewTemplateDetailsNamespace, InterviewTemplateDetailsReducer),
    EffectsModule.forFeature([
      InterviewTemplatesEffects,
      InterviewTemplatesCategoriesEffects,
      InterviewTemplateDetailsEffects,
    ]),
  ],
})
export class InterviewTemplateDataModule {}
